module.exports = __webpack_public_path__ + "img/support-adv-06.b1bb1fe8.png";